<main class="d-flex justify-content-center" [attr.aria-label]="'content.forgot-password-form' | translate">
  <div class="col-sm-12 col-md-9 col-lg-6">
    <h1>{{ 'content.forgot-password' | translate }}</h1>
    <p>{{ 'content.forgot-password-instructions' | translate }}</p>
    <form [formGroup]="formGroup" [ngClass]="{'form-submitted': formSubmitted}" (ngSubmit)="submit(formGroup.value)">
      <div class="form-row">
        <div class="form-group col">
          <label>{{ 'content.person.email' | translate }}:
            <input class="form-control" type="email" autocomplete="on" formControlName="email" #emailInput>
          </label>
          <app-validation-errors [displayErrors]="formSubmitted" [errors]="formGroup.controls.email.errors" [element]="emailInput"></app-validation-errors>
        </div>
      </div>
      <div class="d-flex justify-content-end submit-buttons">
        <button class="tu-button primary tu-shadow pt-2" type="submit">{{ 'content.submit' | translate }}</button>
      </div>
    </form>
  </div>
</main>
